import React, { Fragment, useEffect, useState } from "react";
import HeroBanner from "../component/Common Banner Component/HeroBanner"
import IdvBlogSec from "../component/IdvBlogSec/IdvBlogSec"
import Footer from '../component/Footer/Footer'
import { useParams } from "react-router";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet";

function BlogInner() {

  const [blogsData, setBlogsData] = useState();
  const [catagory, setCatagory] = useState("Genral");
  const [recentBlogs, setRecentBlogs] = useState([]);

  const [loading, setLoading] = useState(true);

  const { id } = useParams();

  let blogAPICalledId = false;
  let allBlogsCalled = false;

  const getAllBlogs = async () => {
    if (allBlogsCalled) return;
    allBlogsCalled = true;

    setLoading(true);
    axios
      .get(`/blogs`, {})
      .then((res) => {
        if (res.data.status === "success") {
          let Updated_recent_blogs = [];
          let blog = res.data.data.find((item) => item.slug_url == id);
          setBlogsData(blog);

          res.data.data.forEach((item) => {
            Updated_recent_blogs.push({
              id: item.blog_id,
              slug_url: item.slug_url,
              logo: item.blog_image,
              blog_description: item.title,
              date: item.published_date,
            });
          });
          setRecentBlogs(Updated_recent_blogs.slice(0, 3));

          axios.get(`/api/categories/catagory/${blog.category}`).then((result)=>{
            if(result.data.status == "success")
            {
              console.log("data",result.data);
              setCatagory(result.data.data.category)
              setLoading(false)
            }
            else{
              setLoading(false)
            }
          })
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("err");
        setBlogsData(null)
        setLoading(false);
      });
  };

  useEffect(() => {
    getAllBlogs();
  }, [id]);


  return (
    <>
    {loading  ? (
          <div
            style={{ width: "100%", height: "100vh" }}
            className="d-flex justify-content-center align-items-center"
          >
            <Spinner
              style={{ color: "white", width: "120px", height: "120px" }}
            />
          </div>
        ) : (
          <>
            <Helmet>
              <title>{blogsData.metaTitle}</title>
              {blogsData.metaDescription && <meta name='description' content={blogsData.metaDescription} />}
              {blogsData.canonicalLink && <link rel="canonical" href={blogsData.canonicalLink}></link>}
            </Helmet>
            <HeroBanner 
              subHeading=""
              Heading={blogsData.title}
              nextLineSpanHeading=""
              Paragraph={`By: HQNS | Published On: ${blogsData.published_date} | Categories: ${catagory}`}
              btn={false}
              bgImg="/images/creatives/blog-inner-hero-bg.jpg"
              heightAuto={true}
            />
            <IdvBlogSec
              blogsData={blogsData.blogs_content}
              text={blogsData.brief_paragraph}
              recentBlogs={recentBlogs}
            />
            <Footer/>
          </>
        )}
    </>
  )
}

export default BlogInner